export default __webpack_public_path__ + "static/media/App-download-Popup-image.4a46fbba.svg";